import React from "react";

import styles from "./style";

import CmsImageBlock from "@gc-npm/components.cms-block.image-block";
import CmsTextBlock from "@gc-npm/components.cms-block.text-block";
import CmsRecomsCarousel from "@gc-npm/components.cms-block.recoms-carousel";
import CmsProductThumbsList from "@gc-npm/components.cms-block.product-thumbs-list"
import CmsBlock from '@gc-npm/components.cms/cms-block';
import CmsImageCluster from "@gc-npm/components.cms-block.cms-image-cluster";
import CmsDetailCardList from "@gc-npm/components.cms-block.cms-detail-card-list";

const BottomSEO = ({ orionInfo, orionAlias }) => {

  return (
    <section className="bottom-seo">

      {orionInfo && orionInfo["cms-component-image-block-list-1"] && (
        <CmsBlock
          alias={orionAlias}
          orionInfo={orionInfo}
          blockName="cms-component-image-block-list-1"
          Component={CmsImageBlock}
        />
      )}

      {orionInfo && orionInfo["cms-component-image-cluster-1"] && (
        <CmsBlock
          alias={orionAlias}
          orionInfo={orionInfo}
          blockName="cms-component-image-cluster-1"
          Component={CmsImageCluster}
        />
      )}

      {orionInfo && orionInfo["cms-component-product-thumbs-1"] && (
        <CmsBlock
          alias={orionAlias}
          orionInfo={orionInfo}
          blockName="cms-component-product-thumbs-1"
          Component={CmsProductThumbsList}
        />
      )}

      {orionInfo && orionInfo["cms-component-recoms-list-1"] && (
        <CmsBlock
          alias={orionAlias}
          orionInfo={orionInfo}
          blockName="cms-component-recoms-list-1"
          Component={CmsRecomsCarousel}
        />
      )}

      {orionInfo && orionInfo["cms-component-detail-card-list-1"] && (
        <CmsBlock
          alias={orionAlias}
          orionInfo={orionInfo}
          blockName="cms-component-detail-card-list-1"
          Component={CmsDetailCardList}
        />
      )}

      {orionInfo && orionInfo["cms-component-text-block-list-1"] && (
        <CmsBlock
          alias={orionAlias}
          orionInfo={orionInfo}
          blockName="cms-component-text-block-list-1"
          Component={CmsTextBlock}
        />
      )}
      <style jsx>{styles}</style>
    </section>
  );
};

export default BottomSEO;
